import { useMutation, useQueryClient } from '@tanstack/react-query';

import { engagementResourcesService } from '../services';

import { engagementResourcesKeys } from './useEngagementResources';

export function useDeleteResource(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => engagementResourcesService.remove(id),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: engagementResourcesKeys.lists() });
      qc.removeQueries({ queryKey: engagementResourcesKeys.detail(id) });
    },
  });
}
